import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import {
  Card,
  CardContent,
  Container,
  Typography,
  Box,
  CircularProgress,
  IconButton,
  Tabs,
  Tab,
  Button,
  TextField,
  Link, InputAdornment,Pagination 
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useLocation, useNavigate } from "react-router-dom";
import DownloadIcon from '@mui/icons-material/Download';
import BtcIcon from "../../assets/btc.svg";
import UsdtIcon from "../../assets/usdt.svg";
import EthIcon from "../../assets/eth.svg";
import UsdcIcon from "../../assets/usdc.svg";
import { refreshToken } from "../../utils/Token";
import jsPDF from "jspdf";
import TransactionDetailsDialog from "./TransactionDetailsDialog";
import CardTransactionDetailsDialog from "./CardTransactionDetailsDialog"; // Import the dialog component
import * as XLSX from 'xlsx';
const generateMockTransactions = (num) => {
  const transactions = [];
  for (let i = 0; i < num; i++) {
    transactions.push({
      id: i,
      blockHash: `0x${Math.random().toString(16).substr(2, 64)}`,
      blockNumber: Math.floor(Math.random() * 1000000),
      from: `0x${Math.random().toString(16).substr(2, 40)}`,
      to: `0x${Math.random().toString(16).substr(2, 40)}`,
      value: (Math.random() * 10).toFixed(4),
      gas: Math.floor(Math.random() * 100000),
      gasPrice: (Math.random() * 100).toFixed(2),
      amount: (Math.random() * 1000).toFixed(2),
      currency: ["ETH", "BTC", "USDT", "USDC"][Math.floor(Math.random() * 4)],
      timestamp: new Date().toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }),
    });
  }
  return transactions;
};

const Wallets = () => {
  // const VISIBLE_FIELDS = [
  //   { field: "blockHash", headerName: "Block hash" },
  //   { field: "blockNumber", headerName: "Block number" },
  //   { field: "from", headerName: "From" },
  //   { field: "to", headerName: "To" },
  //   { field: "value", headerName: "Value" },
  //   { field: "gas", headerName: "Gas" },
  //   { field: "gasPrice", headerName: "Gas price" },
  //   { field: "amount", headerName: "Amount" },
  //   { field: "currency", headerName: "Currency" },
  //   { field: "timestamp", headerName: "Timestamp" }
  // ];
  const [showDetails, setShowDetails] = useState(false);
  const [cardDetails, setCardDetails] = useState(null);
  const [cardAppStatus, setcardAppStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [open, setOpen] = useState(false);
  const [hoveredFeature, setHoveredFeature] = useState(null);
  const [topUpDialogOpen, setTopUpDialogOpen] = useState(false);
  const [cardBalance, setCardBalance] = useState(0.0);
  const [transactions, setTransactions] = useState([]);
  const [dialogCardTransactionOpen, setdialogCardTransactionOpen] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const handleCardTransactionClick = (transaction) => {
    setSelectedTransaction(transaction);
    setdialogCardTransactionOpen(true);
  };

  //transactions dialog with details and pdf download
  //wallet dialogue
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedTransactionId, setSelectedTransactionId] = useState(null);
  const [cardTrasactions, setCardTransactions] = useState([]);
  // Add these with your other state declarations
  const [walletSearch, setWalletSearch] = useState('');
  const [cardSearch, setCardSearch] = useState('');
  // Add these state variables at the top with your other states
  const [page, setPage] = useState(1);
  const rowsPerPage = 20; // Fixed 20 items per page

  // Add this pagination handler
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  // Fetch transactions based on bocard_id
  const fetchTransactions = async (bocardId) => {

    try {
      const response = await axios.get(
        `/api/api/card/transactions/${bocardId}`
      );

      if (response.data.status === "success") {
        setCardTransactions(response.data.data); // Set the transactions if available
      } else {
        console.error("Error fetching transactions:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };

  const fetchBalance = async (bocardId) => {

    try {
      const response = await axios.get(`/api/api/card/balance/${bocardId}`);

      if (response.data) {
        setCardBalance(response.data.payload.result.item1.balance); // Set the transactions if available

      } else {
        console.error("Error fetching balance:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching balance:", error);
    }
  };

  useEffect(() => {
    const fetchCardDetails = async () => {
      try {
        // Obtain email from sessionStorage
        const email = Cookies.get("email");
        if (!email) {
          throw new Error("Email not found in session storage.");
        }

        const bank_url = `${process.env.REACT_APP_BANK_API_URL}/findUser/${email}`;
        const bank_auth_token = `${process.env.REACT_APP_BANK_API_TOKEN}`;



        // Make API call to the bank API
        const response = await axios.get(`/api/api/card/${email}`);



        // Handle the response
        if (response.data.status === "success") {
          if (response.data.data.application_status === "CARD_ISSUED") {
            setcardAppStatus("issued"); // Card is issued
          } else if (response.data.data.application_status === null) {
            setcardAppStatus("not_initiated");
          } else {
            setcardAppStatus("processing"); // Card is still processing
          }

          setCardDetails(response.data.data); // Set card details if available
          // set session card token id
          Cookies.set(
            "cardTokenId",
            response.data.data.card_token_id,
            { secure: true, sameSite: "Strict" }
          );

          if (response.data.data.bocard_id !== null) {
            fetchTransactions(response.data.data.bocard_id);
            fetchBalance(response.data.data.bocard_id);
          }

        } else {
          setcardAppStatus("not_initiated"); // Card is still processing
        }
      } catch (err) {
        console.error("Error fetching card details:", err);
        setError(true); // Show card issuance screen if there's an error
      } finally {
        setLoading(false);
      }
    };

    fetchCardDetails();
  }, []);

  const handleTransactionClick = (transactionId) => {
    setSelectedTransactionId(transactionId);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedTransactionId(null);
  };

  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const email = Cookies.get("email");
        const token = Cookies.get("token");

        const response = await axios.get("/api/api/v1/getAllTransactions", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { email },
        });

        setTransactions(response.data);
        setError(null);
      } catch (error) {
        console.error("Error fetching transactions:", error);
        setError("Failed to load transactions");
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, []);
  // Add useEffect to initialize filtered transactions
  useEffect(() => {
    const filterTransactions = () => {
      let filtered = transactions;

      // Date filtering
      if (startDate || endDate) {
        filtered = filtered.filter(tx => {
          const txDate = new Date(tx.timestamp);
          const start = startDate ? new Date(startDate) : null;
          const end = endDate ? new Date(endDate) : null;

          if (start && end) {
            end.setHours(23, 59, 59, 999);
            return txDate >= start && txDate <= end;
          } else if (start) {
            return txDate >= start;
          } else if (end) {
            end.setHours(23, 59, 59, 999);
            return txDate <= end;
          }
          return true;
        });
      }

      // Search filtering
      if (walletSearch) {
        const searchTerm = walletSearch.toLowerCase();
        filtered = filtered.filter(tx =>
          tx.timestamp?.toLowerCase().includes(searchTerm) ||
          tx.coin?.toLowerCase().includes(searchTerm) ||
          tx.wallet_address?.toLowerCase().includes(searchTerm) ||
          tx.amount?.toString().includes(searchTerm) ||
          tx.asset_address?.toLowerCase().includes(searchTerm)
        );
      }

      setFilteredTransactions(filtered);
    };

    filterTransactions();
  }, [startDate, endDate, transactions, walletSearch]); // Add walletSearch to dependencies


  // Reset function
  const resetDateFilter = () => {
    setStartDate('');
    setEndDate('');
    setWalletSearch(''); // Add this
    setFilteredTransactions(transactions);
  };
  // Add this function in your component
  const downloadExcel = () => {
    try {
      // Create a new workbook
      const workbook = XLSX.utils.book_new();

      // Format the data for Excel
      const excelData = filteredTransactions.map(tx => ({
        'Date/Time': tx.timestamp ? new Date(tx.timestamp).toLocaleString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        }) : 'N/A',
        'Coin': tx.coin || 'N/A',
        'Wallet Address': tx.wallet_address || 'N/A',
        'Amount': tx.amount || 'N/A',
        'Status': tx.status === "0x1" ? "Completed" : "Processing"
      }));

      // Convert data to worksheet
      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Transactions');

      // Generate Excel file
      const currentDate = new Date().toISOString().split('T')[0];
      XLSX.writeFile(workbook, `transactions_${currentDate}.xlsx`);
    } catch (error) {
      console.error('Error downloading Excel:', error);
    }
  };
  // First, add these state variables
  const [cardFilteredTransactions, setCardFilteredTransactions] = useState([]);
  const [cardStartDate, setCardStartDate] = useState('');
  const [cardEndDate, setCardEndDate] = useState('');

  // Add useEffect for card transactions filtering
  // Modify the existing useEffect for card transactions
  useEffect(() => {
    const filterCardTransactions = () => {
      let filtered = cardTrasactions;

      // Date filtering
      if (cardStartDate || cardEndDate) {
        filtered = filtered.filter(tx => {
          const txDate = new Date(tx.date_of_transaction);
          const start = cardStartDate ? new Date(cardStartDate) : null;
          const end = cardEndDate ? new Date(cardEndDate) : null;

          if (start && end) {
            end.setHours(23, 59, 59, 999);
            return txDate >= start && txDate <= end;
          } else if (start) {
            return txDate >= start;
          } else if (end) {
            end.setHours(23, 59, 59, 999);
            return txDate <= end;
          }
          return true;
        });
      }

      // Search filtering
      if (cardSearch) {
        const searchTerm = cardSearch.toLowerCase();
        filtered = filtered.filter(tx =>
          tx.timestamp?.toLowerCase().includes(searchTerm) ||
          tx.transaction_id?.toLowerCase().includes(searchTerm) ||
          tx.description?.toLowerCase().includes(searchTerm) ||
          tx.transaction_type?.toLowerCase().includes(searchTerm) ||
          tx.merchant_name?.toLowerCase().includes(searchTerm) ||
          tx.amount?.toString().includes(searchTerm) ||
          tx.status?.toLowerCase().includes(searchTerm)
        );
      }

      setCardFilteredTransactions(filtered);
      setPage(1); // Reset to first page when filtering
    };

    filterCardTransactions();
  }, [cardStartDate, cardEndDate, cardTrasactions, cardSearch]); // Add cardSearch to dependencies
// Updated search handler
const handleSearchChange = (e) => {
  setCardSearch(e.target.value);
  setPage(1); // Reset page when search changes
};
  // Reset function for card transactions
  const resetCardDateFilter = () => {
    setCardStartDate('');
    setCardEndDate('');
    setCardSearch(''); // Add this
    setPage(1); // Reset to first page
    setCardFilteredTransactions(cardTrasactions);
  };

  // Download function for card transactions
  const downloadCardExcel = () => {
    try {
      const workbook = XLSX.utils.book_new();
    
      // Get only current page data
      const currentPageData = cardFilteredTransactions
        .slice((page - 1) * rowsPerPage, page * rowsPerPage);
    
      // Format the data for Excel
      const cardData = currentPageData.map((tx, index) => ({
        'S.No': ((page - 1) * rowsPerPage) + index + 1, // Maintains continuous numbering
        'Date/Time': tx.date_of_transaction || 'N/A',
        'UUID': tx.transaction_id 
          ? `${tx.transaction_id.substring(0, 2)}***${tx.transaction_id.slice(-6)}`
          : 'N/A',
        'Transaction Type': tx.transaction_type || 'N/A',
        'Merchant Name': tx.merchant_name || 'N/A',
        'Description': tx.description 
          ? tx.description.length > 15
            ? `${tx.description.substring(0, 5)}....${tx.description.slice(-10)}`
            : tx.description
          : 'N/A',
        'Amount': tx.transaction_mode === "Debit" 
          ? `-$${tx.amount}` 
          : tx.transaction_mode === "Credit" 
            ? `+$${tx.amount}` 
            : 'N/A',
        'Status': tx.status === "COMPLETION" 
          ? "Completed" 
          : tx.status 
            ? tx.status.charAt(0).toUpperCase() + tx.status.slice(1).toLowerCase()
            : 'N/A'
      }));
    
      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(cardData);
    
      // Auto-size columns
      const maxWidths = {};
      cardData.forEach(row => {
        Object.keys(row).forEach(key => {
          const cellLength = String(row[key]).length;
          maxWidths[key] = Math.max(maxWidths[key] || 0, cellLength, key.length);
        });
      });
    
      worksheet['!cols'] = Object.keys(maxWidths).map(key => ({
        wch: maxWidths[key] + 2 // Add padding
      }));
    
      // Add styling to header row
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const address = XLSX.utils.encode_cell({ r: 0, c: C });
        if (worksheet[address]) {
          worksheet[address].s = {
            font: { bold: true },
            fill: { 
              fgColor: { rgb: "7517A7" },
              patternType: 'solid'
            },
            alignment: { horizontal: 'center' },
            color: { rgb: "FFFFFF" }
          };
        }
      }
    
      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Card Transactions');
    
      // Generate detailed filename
      let filename = 'card_transactions';
    
      // Add page number
      filename += `_page${page}`;
    
      // Add date range if filters are applied
      if (cardStartDate && cardEndDate) {
        filename += `_${cardStartDate}_to_${cardEndDate}`;
      } else if (cardStartDate) {
        filename += `_from_${cardStartDate}`;
      } else if (cardEndDate) {
        filename += `_until_${cardEndDate}`;
      }
    
      // Add search term if present
      if (cardSearch) {
        const sanitizedSearch = cardSearch.replace(/[^a-zA-Z0-9]/g, '_');
        filename += `_search_${sanitizedSearch}`;
      }
    
      // Add current date and time for uniqueness
      filename += '_' + new Date().toISOString().replace(/[:.]/g, '-');
    
      // Write file
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    
    } catch (error) {
      console.error('Error downloading Excel:', error);
    }
  };
  
  // Function to download all search results
  const downloadSearchResults = () => {
    try {
      const workbook = XLSX.utils.book_new();
      
      // Use all filtered data (includes search results)
      const cardData = cardFilteredTransactions.map((tx, index) => ({
        'S.No': index + 1,
        'Date/Time': tx.date_of_transaction || 'N/A',
        'UUID': tx.transaction_id 
          ? `${tx.transaction_id.substring(0, 2)}***${tx.transaction_id.slice(-6)}`
          : 'N/A',
        'Transaction Type': tx.transaction_type || 'N/A',
        'Merchant Name': tx.merchant_name || 'N/A',
        'Description': tx.description 
          ? tx.description.length > 15
            ? `${tx.description.substring(0, 5)}....${tx.description.slice(-10)}`
            : tx.description
          : 'N/A',
        'Amount': tx.transaction_mode === "Debit" 
          ? `-$${tx.amount}` 
          : tx.transaction_mode === "Credit" 
            ? `+$${tx.amount}` 
            : 'N/A',
        'Status': tx.status === "COMPLETION" 
          ? "Completed" 
          : tx.status 
            ? tx.status.charAt(0).toUpperCase() + tx.status.slice(1).toLowerCase()
            : 'N/A'
      }));
  
      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(cardData);
  
      // Auto-size columns
      const maxWidths = {};
      cardData.forEach(row => {
        Object.keys(row).forEach(key => {
          const cellLength = String(row[key]).length;
          maxWidths[key] = Math.max(maxWidths[key] || 0, cellLength, key.length);
        });
      });
  
      worksheet['!cols'] = Object.keys(maxWidths).map(key => ({
        wch: maxWidths[key] + 2
      }));
  
      // Add styling to header row
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const address = XLSX.utils.encode_cell({ r: 0, c: C });
        if (worksheet[address]) {
          worksheet[address].s = {
            font: { bold: true },
            fill: { 
              fgColor: { rgb: "7517A7" },
              patternType: 'solid'
            },
            alignment: { horizontal: 'center' },
            color: { rgb: "FFFFFF" }
          };
        }
      }
  
      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Search Results');
  
      // Generate filename
      let filename = 'card_transactions';
      
      if (cardSearch) {
        filename += `_search_${cardSearch.replace(/[^a-zA-Z0-9]/g, '_')}`;
      }
      
      if (cardStartDate || cardEndDate) {
        filename += `_${cardStartDate || 'start'}_to_${cardEndDate || 'end'}`;
      }
      
      filename += '_' + new Date().toISOString().replace(/[:.]/g, '-');
  
      // Write file
      XLSX.writeFile(workbook, `${filename}.xlsx`);
  
    } catch (error) {
      console.error('Error downloading search results:', error);
    }
  };
  
  // Updated UI with both export options
  <Box sx={{ display: 'flex', gap: 1 }}>
    <Button
      variant="outlined"
      onClick={downloadCardExcel}
      startIcon={<DownloadIcon />}
      disabled={cardFilteredTransactions.length === 0}
      sx={{
        minWidth: { xs: '100%', sm: 'auto' },
        color: '#7517a7',
        borderColor: '#7517a7',
        height: '30px',
        minHeight: '30px',
        padding: '0 15px',
        '&:hover': {
          borderColor: '#5c1184',
        },
        '&.Mui-disabled': {
          borderColor: 'rgba(117, 23, 167, 0.38)',
          color: 'rgba(117, 23, 167, 0.38)'
        },
        mb: { sm: 2, xs: 2 }
      }}
    >
      Export Page {page}
    </Button>
  
    <Button
      variant="outlined"
      onClick={downloadSearchResults}
      startIcon={<DownloadIcon />}
      disabled={cardFilteredTransactions.length === 0}
      sx={{
        minWidth: { xs: '100%', sm: 'auto' },
        color: '#7517a7',
        borderColor: '#7517a7',
        height: '30px',
        minHeight: '30px',
        padding: '0 15px',
        '&:hover': {
          borderColor: '#5c1184',
        },
        '&.Mui-disabled': {
          borderColor: 'rgba(117, 23, 167, 0.38)',
          color: 'rgba(117, 23, 167, 0.38)'
        },
        mb: { sm: 2, xs: 2 }
      }}
    >
      {cardSearch ? 'Export Search Results' : 'Export All'}
    </Button>
  </Box>
  
  
  // Add an "Export All" function if needed
  const downloadAllCardExcel = () => {
    try {
      const workbook = XLSX.utils.book_new();
      
      // Use all filtered data instead of just current page
      const cardData = cardFilteredTransactions.map((tx, index) => ({
        // Same mapping as above
      }));
      
      // ... rest of the export logic ...
      
      XLSX.writeFile(workbook, `card_transactions_all_${new Date().toISOString()}.xlsx`);
    } catch (error) {
      console.error('Error downloading Excel:', error);
    }
  };
  
  // Updated UI with both export options
  <Box sx={{ display: 'flex', gap: 1 }}>
    <Button
      variant="outlined"
      onClick={downloadCardExcel}
      startIcon={<DownloadIcon />}
      disabled={cardFilteredTransactions.length === 0}
      sx={{
        minWidth: { xs: '100%', sm: 'auto' },
        color: '#7517a7',
        borderColor: '#7517a7',
        height: '30px',
        minHeight: '30px',
        padding: '0 15px',
        '&:hover': {
          borderColor: '#5c1184',
        },
        '&.Mui-disabled': {
          borderColor: 'rgba(117, 23, 167, 0.38)',
          color: 'rgba(117, 23, 167, 0.38)'
        },
        mb: { sm: 2, xs: 2 }
      }}
    >
      Export Page {page}
    </Button>
  
    <Button
      variant="outlined"
      onClick={downloadAllCardExcel}
      startIcon={<DownloadIcon />}
      disabled={cardFilteredTransactions.length === 0}
      sx={{
        minWidth: { xs: '100%', sm: 'auto' },
        color: '#7517a7',
        borderColor: '#7517a7',
        height: '30px',
        minHeight: '30px',
        padding: '0 15px',
        '&:hover': {
          borderColor: '#5c1184',
        },
        '&.Mui-disabled': {
          borderColor: 'rgba(117, 23, 167, 0.38)',
          color: 'rgba(117, 23, 167, 0.38)'
        },
        mb: { sm: 2, xs: 2 }
      }}
    >
      Export All
    </Button>
  </Box>
  
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" m={3}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" align="center" m={3}>
        {error}
      </Typography>
    );
  }

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const token = Cookies.get("token");
  //       const response = await axios.get("/api/dashboard", {
  //         headers: { Authorization: `Bearer ${token}` },
  //       });
  //       setMessage(response.data);
  //     } catch (error) {
  //       setMessage("Error fetching dashboard data");
  //       navigate("/login");
  //     }
  //   };

  //   fetchData();
  //   const interval = setInterval(() => {
  //     refreshToken();
  //   }, 15 * 60 * 1000);

  //   return () => clearInterval(interval);
  // }, [navigate]);

  // useEffect(() => {
  //   const transactions = generateMockTransactions(100);
  //   setData(transactions);
  //   setLoading(false);
  // }, []);

  // const queryParams = new URLSearchParams(location.search);
  // const initialCurrency = queryParams.get("tab") || "BTC";
  // const [selectedCurrency, setSelectedCurrency] = useState(initialCurrency);

  // useEffect(() => {
  //   const tab = queryParams.get("tab");
  //   if (tab && tab !== selectedCurrency) {
  //     setSelectedCurrency(tab);
  //   }
  // }, [location.search]);

  return (
    <Container maxWidth="100" sx={{ backgroundColor: "#f5f5f5" }}>
      {/* <Card sx={{ borderRadius: 4, boxShadow: 0, mt: 2 }}>
        <CardContent>
          <Typography variant="body1" color="#7517a7" fontWeight="bold" gutterBottom>
            Recent Transactions
          </Typography>
          <Box sx={{ height: 400, width: "100%" }}>
            <DataGrid
              rows={data.slice(-4)}
              columns={VISIBLE_FIELDS.map((column) => ({
                field: column.field,
                headerName: column.headerName,
                width: 150,
                headerClassName: 'super-app-theme--header',
              }))}
              loading={loading}
              components={{ Toolbar: GridToolbar }}
              sx={{
                '& .super-app-theme--header': {
                  fontWeight: 600,
                },
                '& .MuiDataGrid-columnHeader': {
                  // backgroundColor: '#f5f5f5',
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                  fontWeight: 600,
                  fontSize: '0.875rem'
                },
                '& .MuiDataGrid-cell': {
                  fontSize: '0.875rem'
                },
                border: 1,
                borderColor: 'divider',
                '& .MuiDataGrid-row:nth-of-type(even)': {
                  backgroundColor: '#f8f8f8',
                },
              }}
            />
          </Box>
        </CardContent>
      </Card> */}
      <Card sx={{ borderRadius: 4, boxShadow: 0, mt: 2 }}>
        <CardContent>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2
          }}>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Typography variant="body1" fontWeight="bold" color="#7517a7">
                Recent Transactions
              </Typography>
            </Box>

            {/* <Link
              href="/transactions"
              sx={{
                color: '#7517a7',
                textDecoration: 'none',
                fontSize: '14px',
                '&:hover': {
                  textDecoration: 'underline',
                }
              }}
            >
              See more
            </Link> */}
          </Box>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              sx={{
                "& .Mui-selected": {
                  color: "#542a74 !important",
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "#542a74",
                },
              }}
            >
              <Tab
                label="Wallets"
                sx={{
                  textTransform: "none",
                  fontWeight: 500,
                }}
              />
              <Tab
                label="Cards"
                sx={{
                  textTransform: "none",
                  fontWeight: 500,
                }}
              />
            </Tabs>
          </Box>
          {tabValue === 0 && (
            <Box sx={{ overflowX: "auto", borderRadius: 4 }}>
              <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                mb: 2,
                mt: 2
              }}>
                {/* Left side - Date filters and buttons */}
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: 2
                }}>
                  <TextField
                    type="date"
                    size="small"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    sx={{
                      width: {
                        xs: '100%',    // Full width on mobile
                        sm: '170px',   // Tablet
                        md: '190px',   // Desktop
                        lg: '200px',   // Large screens
                        xl: '220px'    // Extra large screens
                      },
                      mr: { sm: 2 },
                      '& .MuiInputBase-root': {
                        height: '30px'
                      },
                      '& .MuiOutlinedInput-input': {
                        padding: '5px 14px',
                      },
                      mb: { sm: 2, xs: 2 } // Add margin bottom for smaller screens
                    }}
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        transform: 'translate(14px, -9px) scale(0.75)'
                      }
                    }}
                    label="Start Date"
                  />
                  <TextField
                    type="date"
                    size="small"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    sx={{
                      width: {
                        xs: '100%',    // Full width on mobile
                        sm: '170px',   // Tablet
                        md: '190px',   // Desktop
                        lg: '200px',   // Large screens
                        xl: '220px'    // Extra large screens
                      },
                      mr: { sm: 2 },
                      '& .MuiInputBase-root': {
                        height: '30px'
                      },
                      '& .MuiOutlinedInput-input': {
                        padding: '5px 14px',
                      },
                      mb: { sm: 2, xs: 2 } // Add margin bottom for smaller screens
                    }}
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        transform: 'translate(14px, -9px) scale(0.75)'
                      }
                    }}
                    label="End Date"
                  />
                  <Button
                    variant="outlined"
                    onClick={resetDateFilter}
                    sx={{
                      minWidth: { xs: '100%', sm: 'auto' },
                      color: '#7517a7',
                      borderColor: '#7517a7',
                      height: '30px',
                      minHeight: '30px',
                      padding: '0 15px',
                      mr: { sm: 2 },
                      '&:hover': {
                        borderColor: '#5c1184',
                      },
                      mb: { sm: 2, xs: 2 } // Add margin bottom for smaller screens
                    }}
                  >
                    Reset
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={downloadExcel}
                    startIcon={<DownloadIcon />}
                    sx={{
                      minWidth: { xs: '100%', sm: 'auto' },
                      color: '#7517a7',
                      borderColor: '#7517a7',
                      mr: { xl: 2, lg: 2 },
                      height: '30px',
                      minHeight: '30px',
                      padding: '0 15px',
                      '&:hover': {
                        borderColor: '#5c1184',
                      },
                      mb: { sm: 2, xs: 2 } // Add margin bottom for smaller screens
                    }}
                  >
                    Export 
                  </Button>
                </Box>
                <TextField
                  placeholder="Search transactions..."
                  size="small"
                  value={walletSearch}
                  onChange={(e) => setWalletSearch(e.target.value)}
                  sx={{
                    width: {
                      xs: '100%',
                      sm: '250px'
                    },
                    color: '#7517a7',
                    borderColor: '#7517a7',
                    mr: { sm: 2 },
                    mb: { xs: 2, sm: 2 },
                    '& .MuiInputBase-root': {
                      height: '30px'
                    },
                    '& .MuiOutlinedInput-input': {
                      padding: '5px 14px',
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ fontSize: 20, color: '#666666' }} />
                      </InputAdornment>
                    ),
                  }}
                />

              </Box>
              {filteredTransactions.length > 0 ? (
                <>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    borderRadius: "8px",
                    overflow: "hidden",
                    fontSize: "14px",
                  }}
                >
                  <thead>
                    <tr
                      style={{ backgroundColor: "#f5f5f5", textAlign: "left" }}
                    >
                      <th style={{ padding: "12px", fontWeight: "bold" }}>
                        Date
                      </th>
                      <th style={{ padding: "12px", fontWeight: "bold" }}>
                        Coin
                      </th>
                      <th style={{ padding: "12px", fontWeight: "bold" }}>
                        Wallet Address
                      </th>
                      <th style={{ padding: "12px", fontWeight: "bold" }}>
                        Amount
                      </th>
                      <th style={{ padding: "12px", fontWeight: "bold" }}>
                        Status
                      </th>
                      <th style={{ padding: "12px", fontWeight: "bold" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredTransactions.slice(0, 5).map((tx, index) => (
                      <tr
                        key={index}
                        style={{
                          backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        <td style={{ padding: "12px" }}>
                          {tx.timestamp
                            ? new Date(tx.timestamp).toLocaleString("en-US", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                            : "N/A"}
                        </td>
                        <td style={{ padding: "12px" }}>{tx.coin || "N/A"}</td>
                        <td style={{ padding: "12px" }}>
                          {tx.asset_address || tx.wallet_address || "N/A"}
                        </td>
                        <td style={{ padding: "12px" }}>
                          {tx.amount ? `${tx.amount} ${tx.coin}` : "N/A"}
                        </td>
                        <td style={{ padding: "12px" }}>
                          {tx.status === "0x1" ? (
                            <Typography
                              variant="body2"
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                color: "green",
                                fontWeight: "bold",
                              }}
                            >
                              <span
                                style={{
                                  width: 8,
                                  height: 8,
                                  backgroundColor: "green",
                                  borderRadius: "50%",
                                  display: "inline-block",
                                  marginRight: 8,
                                }}
                              />
                              Completed
                            </Typography>
                          ) : (
                            <Typography
                              variant="body2"
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                color: "orange",
                                fontWeight: "bold",
                              }}
                            >
                              <span
                                style={{
                                  width: 8,
                                  height: 8,
                                  backgroundColor: "orange",
                                  borderRadius: "50%",
                                  display: "inline-block",
                                  marginRight: 8,
                                }}
                              />
                              Processing
                            </Typography>
                          )}
                        </td>
                        <td style={{ padding: "12px" }}>
                          <IconButton
                            aria-label="details"
                            size="small"
                            onClick={() => handleTransactionClick(tx.id)}
                          >
                            <ArrowForwardIosIcon fontSize="inherit" />
                          </IconButton>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                 {/* Pagination controls */}
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        mt: 3,
        mb: 2
      }}
    >
      <Pagination
        count={Math.ceil(filteredTransactions.length / rowsPerPage)}
        page={page}
        onChange={handlePageChange}
        color="primary"
        sx={{
          '& .MuiPaginationItem-root': {
            color: '#7517a7',
            '&.Mui-selected': {
              backgroundColor: '#7517a7',
              color: 'white',
              '&:hover': {
                backgroundColor: '#5c1184',
              },
            },
          },
        }}
      />
    </Box>
                </>
              ) : (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ textAlign: "center", mt: 2 }}
                >
                  No transactions found
                </Typography>
              )}
            </Box>
          )}

          {tabValue === 1 && (
            <Box sx={{ overflowX: "auto", borderRadius: 4 }}>
              <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                mb: 2,
                mt: 2
              }}>
                {/* Left side - Date filters and buttons */}
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: 2
                }}>
                  <TextField
                    type="date"
                    size="small"
                    value={cardStartDate}
                    onChange={(e) => setCardStartDate(e.target.value)}
                    sx={{
                      width: {
                        xs: '100%',    // Full width on mobile
                        sm: '170px',   // Tablet
                        md: '190px',   // Desktop
                        lg: '200px',   // Large screens
                        xl: '220px'    // Extra large screens
                      },
                      mb: { sm: 2, xs: 2 }, // Add margin bottom for smaller screens
                      mr: { sm: 2 },
                      '& .MuiInputBase-root': {
                        height: '30px'
                      },
                      '& .MuiOutlinedInput-input': {
                        padding: '5px 14px',
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        transform: 'translate(14px, -9px) scale(0.75)'
                      }
                    }}
                    label="Start Date"
                  />
                  <TextField
                    type="date"
                    size="small"
                    value={cardEndDate}
                    onChange={(e) => setCardEndDate(e.target.value)}
                    sx={{
                      width: {
                        xs: '100%',    // Full width on mobile
                        sm: '170px',   // Tablet
                        md: '190px',   // Desktop
                        lg: '200px',   // Large screens
                        xl: '220px'    // Extra large screens
                      },
                      mr: { sm: 2 },
                      '& .MuiInputBase-root': {
                        height: '30px'
                      },
                      '& .MuiOutlinedInput-input': {
                        padding: '5px 14px',
                      },
                      mb: { sm: 2, xs: 2 } // Add margin bottom for smaller screens
                    }}
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        transform: 'translate(14px, -9px) scale(0.75)'
                      }
                    }}
                    label="End Date"
                  />
                  <Button
                    variant="outlined"
                    onClick={resetCardDateFilter}
                    sx={{
                      minWidth: { xs: '100%', sm: 'auto' },
                      color: '#7517a7',
                      borderColor: '#7517a7',
                      height: '30px',
                      minHeight: '30px',
                      padding: '0 15px',
                      mr: { sm: 2 },
                      '&:hover': {
                        borderColor: '#5c1184',
                      },
                      mb: { sm: 2, xs: 2 } // Add margin bottom for smaller screens
                    }}
                  >
                    Reset
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={downloadCardExcel}
                    startIcon={<DownloadIcon />}
                    sx={{
                      minWidth: { xs: '100%', sm: 'auto' },
                      mr: { xl: 2, lg: 2 },
                      color: '#7517a7',
                      borderColor: '#7517a7',
                      height: '30px',
                      minHeight: '30px',
                      padding: '0 15px',
                      '&:hover': {
                        borderColor: '#5c1184',
                      },
                      mb: { sm: 2, xs: 2 } // Add margin bottom for smaller screens
                    }}
                  >
                    Export
                  </Button>
                </Box>
                <TextField
                  placeholder="Search transactions..."
                  size="small"
                  value={cardSearch}
                  onChange={(e) => setCardSearch(e.target.value)}
                  sx={{
                    width: {
                      xs: '100%',
                      sm: '250px'
                    },
                    color: '#7517a7',
                    borderColor: '#7517a7',
                    mr: { sm: 2 },
                    mb: { xs: 2, sm: 2 },
                    '& .MuiInputBase-root': {
                      height: '30px'
                    },
                    '& .MuiOutlinedInput-input': {
                      padding: '5px 14px',
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ fontSize: 20, color: '#666666' }} />
                      </InputAdornment>
                    ),
                  }}
                />

              </Box>
              <Box> {/* Added parent Box */}
                {cardFilteredTransactions.length > 0 ? (
                  <>
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        borderRadius: "8px",
                        overflow: "hidden",
                        fontSize: "14px",
                      }}
                    >
                      <thead>
                        <tr
                          style={{ backgroundColor: "#f5f5f5", textAlign: "left" }}
                        >
                          <th style={{ padding: "12px", fontWeight: "bold" }}>
                            Date/Time
                          </th>
                          <th style={{ padding: "12px", fontWeight: "bold" }}>
                            UUID
                          </th>
                          <th style={{ padding: "12px", fontWeight: "bold" }}>
                            Transaction Type
                          </th>
                          <th style={{ padding: "12px", fontWeight: "bold" }}>
                            Merchant Name
                          </th>
                          <th style={{ padding: "12px", fontWeight: "bold" }}>
                            Description
                          </th>
                          <th style={{ padding: "12px", fontWeight: "bold" }}>
                            Amount
                          </th>
                          <th style={{ padding: "12px", fontWeight: "bold" }}>
                            Status
                          </th>
                          <th style={{ padding: "12px", fontWeight: "bold" }}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {cardFilteredTransactions
                          .slice((page - 1) * rowsPerPage, page * rowsPerPage)
                          .map((tx, index) => (
                            <tr
                              key={index}
                              style={{
                                backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9",
                                borderBottom: "1px solid #ddd",
                              }}
                            >
                              <td style={{ padding: "12px" }}>
                                {tx.date_of_transaction || "N/A"}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {tx.transaction_id
                                  ? `${tx.transaction_id.substring(0, 2)}***${tx.transaction_id.slice(-6)}`
                                  : "N/A"}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {tx.transaction_type || "N/A"}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {tx.merchant_name || "N/A"}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {tx.description
                                  ? tx.description.length > 15
                                    ? `${tx.description.substring(0, 5)}....${tx.description.slice(-10)}`
                                    : tx.description
                                  : "N/A"}
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  fontWeight:
                                    tx.transaction_mode === "Credit"
                                      ? "bold"
                                      : "normal",
                                }}
                              >
                                {tx.transaction_mode === "Debit"
                                  ? `-$${tx.amount}`
                                  : tx.transaction_mode === "Credit"
                                    ? `+$${tx.amount}`
                                    : "N/A"}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {tx.status === "COMPLETION" ? (
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      color: "green",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <span
                                      style={{
                                        width: 8,
                                        height: 8,
                                        backgroundColor: "green",
                                        borderRadius: "50%",
                                        display: "inline-block",
                                        marginRight: 8,
                                      }}
                                    ></span>
                                    Completed
                                  </Typography>
                                ) : (
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      color:
                                        tx.status === "DECLINED" ? "red" : "orange",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <span
                                      style={{
                                        width: 8,
                                        height: 8,
                                        backgroundColor: "green",
                                        borderRadius: "50%",
                                        display: "inline-block",
                                        marginRight: 8,
                                      }}
                                    ></span>
                                    {tx.status
                                      ? tx.status.charAt(0).toUpperCase() +
                                      tx.status.slice(1).toLowerCase()
                                      : "N/A"}
                                  </Typography>
                                )}
                              </td>
                              <td style={{ padding: "12px" }}>
                                <IconButton
                                  aria-label="details"
                                  size="small"
                                  onClick={() => handleCardTransactionClick(tx)}
                                >
                                  <ArrowForwardIosIcon fontSize="inherit" />
                                </IconButton>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    {/* Pagination */}
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mt: 3,
                        mb: 2
                      }}
                    >
                      <Pagination
                        count={Math.ceil(cardFilteredTransactions.length / rowsPerPage)}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        sx={{
                          '& .MuiPaginationItem-root': {
                            color: '#7517a7',
                            '&.Mui-selected': {
                              backgroundColor: '#7517a7',
                              color: 'white',
                              '&:hover': {
                                backgroundColor: '#5c1184',
                              },
                            },
                          },
                        }}
                      />
                    </Box>
                  </>
                ) : (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ textAlign: "center", mt: 2 }}
                  >
                    No transactions found
                  </Typography>
                )}
              </Box>
            </Box>
          )}
        </CardContent>
      </Card>
      <TransactionDetailsDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        transactionId={selectedTransactionId}
      />
      <CardTransactionDetailsDialog
        open={dialogCardTransactionOpen}
        onClose={() => setdialogCardTransactionOpen(false)}
        transaction={selectedTransaction}
      />
    </Container>
  );
};

export default Wallets;
